import { render, staticRenderFns } from "./MyContract.vue?vue&type=template&id=b9941914&scoped=true&"
import script from "./MyContract.vue?vue&type=script&lang=js&"
export * from "./MyContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9941914",
  null
  
)

export default component.exports